/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryResponse,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability500,
} from "../../types/individualPaymentTraceabilityController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability.ts";

function getGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityUrl(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityPathParams["financialPersonId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/financial-people/${financialPersonId}/traceability` as const,
  };
  return res;
}

/**
 * @description Retorna os registros de auditoria do plano (GA_TRACEABILITY, entidade CourseFinancialPerson). Migrado do legado IndividualPayment/LoadFinancialPersonTraceabilityGridDataAsync. **(Requer Authorization para autenticação)**
 * @summary Retorna a rastreabilidade (auditoria por campo) de um plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/traceability}
 */
export async function getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityPathParams["financialPersonId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityUrl(
      financialPersonId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
